import apolloClient from '../../apolloClient';
import customerQueries from '../queries/customer';
import customerMutations from '../mutations/customer';

const getCustomers = async (variables) =>
  apolloClient.query({
    query: customerQueries.GET_CUSTOMER,
    fetchPolicy: 'no-cache',
    variables,
  });

const getCustomerById = async (variables) =>
  apolloClient.query({
    query: customerQueries.GET_CUSTOMER_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const createCustomer = async (variables) =>
  apolloClient.mutate({
    mutation: customerMutations.CREATE_CUSTOMER,
    fetchPolicy: 'no-cache',
    refetchQueries: ['GetCustomersByWorkspace'],
    variables,
  });

const updateCustomerById = async (variables) =>
  apolloClient.mutate({
    mutation: customerMutations.UPDATE_CUSTOMER_BY_ID,
    fetchPolicy: 'no-cache',
    refetchQueries: ['GetCustomersByWorkspace'],
    variables,
  });

const deleteCustomerById = async (variables) =>
  apolloClient.mutate({
    mutation: customerMutations.DELETE_CUSTOMER_BY_ID,
    fetchPolicy: 'no-cache',
    refetchQueries: ['GetCustomersByWorkspace'],
    variables,
  });

export default {
  getCustomers,
  getCustomerById,
  createCustomer,
  updateCustomerById,
  deleteCustomerById,
};
